<template>
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-header>
        <template v-slot:default="{ open }">
          <v-row no-gutters>
            <v-col cols="4"><h4>Elenco prodotti del gestionale configurati ma non mappati con sito eCommerce: {{ totaleArticoli ? totaleArticoli : '' }}</h4></v-col>
            <v-col cols="7" class="text--secondary"><span class="red--text">{{erroreAccesso}}</span></v-col>
            <v-col cols="1" v-if="open"><v-btn @click.stop="getDataFromApi">Aggiorna</v-btn></v-col>
          </v-row>
        </template>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row no-gutters>
          <v-col class="text-caption">Seleziona i prodotti del Gestionale da creare su eCommerce. Vengono create le varianti corrispondeti a tutti i colori e le taglie selezionate</v-col>
        </v-row>
        <v-data-table
          v-model="selected"
          :show-select="totaleArticoli > 0"
          item-key="_id"
          :headers="headers"
          :items="articoliSorted"
          :options.sync="options"
          
          :loading="loading"
          class="elevation-1"
          :disable-sort="true"
          :footer-props="{
            itemsPerPageOptions: [5, 10, 15, 50, 100]
          }"       
          dense
        >
        <!-- :server-items-length="totaleArticoli" -->
          <template v-slot:top>
            <v-row align="center" justify="end" dense>
              <v-col md="3" class="mb-3">
                <v-text-field v-model="filtroProdotto" dense outlined label="Ricerca per codice o descrizione" clearable hide-details ></v-text-field>
              </v-col>
            </v-row>
          </template>        
          <template v-slot:[`item.speciali`]="{ item }">
            <v-icon v-if="item.eCommerce && item.eCommerce.abilita" small title="Abilitato per eCommerce" class="ml-2">{{ allegatiEcommerce(item) ? 'mdi-cart' : 'mdi-cart-outline' }}</v-icon>
          </template>      
<!--           <template v-slot:[`item.name`]="{ item }">
            <div title="Visualizza prodotto online" @click="apriCommerce(item)" class="text-decoration-underline" style="cursor: pointer;">{{ item.name }}</div>
          </template> 
          <template v-slot:[`item.variations`]="{ item }">
            <span :title="item.attributes.length > 0 ? item.attributes[0].options.join(', ') : ''" style="cursor: help;">{{ item.variations.length }}</span>
          </template>
          <template v-slot:[`item.images`]="{ item }">
            <v-img v-if="item.images.length > 0" :src="item.images[0].src" max-width="50"></v-img>
          </template> -->
          <template v-slot:[`item.codice`]="{ item }">
            <a :href="'/v-articoli/' + item._id" title="Apre l'anagrafica articolo"><span>{{ item.codice }}</span></a>
          </template>  
          <template v-slot:no-data>
            <h3 class="m-3">Per popolare la lista scarica l'elenco dei prodotti dal sito !!</h3>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" class="articoliSelected">
              <v-tabs dense v-model="tab[item._id]">
                <v-tab key="associaProdotto" class="articoliSelected">{{item.prodotto ? 'Prodotto associato' : 'Associa prodotto esistente'}}</v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab[item._id]">
                <v-tab-item key="associaProdotto">
                  <!-- <associa-prodotto-esistente :item="item" :prodottiAbilitatiECommerce="prodottiAbilitatiECommerce" :trigger="trigRefresh" @aggiorna="associaProdotto"/> -->
                </v-tab-item>   
              </v-tabs-items>
            </td>
          </template>  
          <template v-slot:[`footer.prepend`]>
            <!-- <v-switch v-model="mostraSoloNonAssociati" class="pb-2" dense inset label="Mostra solo non associati"></v-switch> -->
            <v-btn v-if="selected.length > 0" color="primary" class="ml-5" @click="onCreaProdottiEcommerce">Crea prodotti su eCommerce</v-btn>
          </template>
        </v-data-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
  import _ from 'lodash'
  import configurazioni from '@/services/configurazioniService.js'
  import prodotti from '@/services/prodottiService.js'
  import { sanitize } from '@/components/helpers'
  import eCommerce from '@/services/eCommerceService'

  export default {
    components: {
    },
    props: {
    },
    data: () => ({
        totaleArticoli: 0,
        articoli: [],
        selected: [],
        loading: false,
        options: { itemsPerPage: 15 },
        headersDefault: [ // Caricato se non ci sono impostazioni diverse nel DB
          { text: 'Codice', value: 'codice', align: 'start' },
          { text: 'Descrizione', value: 'descrizione' },
          { text: 'Taglia', value: 'varianti.variante1.descrizione' },
          { text: 'Colore', value: 'varianti.variante2.descrizione' },
          { text: 'Marchio', value: 'marchio' },
          /* { text: 'Listino €', value: 'prezzo.L2.base', align: 'end' }, */
          { text: 'Prezzo €', name: 'prezzo', value: 'prezzo.L1.base', align: 'end' },
          { text: 'Prezzo Web €', name: 'prezzo', value: 'prezzo.web', align: 'end' },
          /* { text: 'Acquisto €', value: 'magazzino.prezzoAcquisto', align: 'end' }, */
          { text: 'Giacenza', value: 'magazzino.giacenza', align: 'end' },
          { text: 'Giacenza web', value: 'magazzino.giacenzaWeb', align: 'end' },
          { text: 'Giacenza online', value: 'eCommerce.giacenza', align: 'end' }
        ],
        headersBase: [
         /*  { text: 'Actions', value: 'actions', sortable: false }, */
          { text: '', value: 'data-table-expand' }
        ],
        headersSpeciali: [
          { text: '', value: 'speciali', width: 80 }
        ],       

/*         headersDefault: [ // Caricato se non ci sono impostazioni diverse nel DB
          { text: 'Codice', value: 'id', align: 'start' },
          { text: 'Nome', value: 'name' },
          { text: 'Slug', value: 'slug' },
          { text: 'Prezzo €', value: 'price', align: 'end' },
          { text: 'Listino €', value: 'regular_price', align: 'end' },
          { text: 'Offerta €', value: 'sale_price', align: 'end' },
          
          { text: 'Giacenza', value: 'stock_quantity', align: 'end' },
          { text: 'Opzioni', value: 'variations', align: 'center' },
          { text: 'Foto', value: 'images', align: 'start' },
          { text: '', value: 'data-table-expand' }
        ], 
        headersSpeciali: [
          { text: '', value: 'speciali', width: 80 }
        ],  */  
        headersBO: [],
        // mostraSoloNonAssociati: true,
        datiFiscali: null,
        nomeAttributoTaglia: 'Taglia',
        nomeAttributoColore: 'Colore',
        trigRefresh: 1,
        expanded: [],
        singleExpand: false,
        tab: {},
        prodottiAbilitatiECommerce: [],
        filtroProdotto: '',
        erroreAccesso: '',
        prodottiNonAssociati: [],
        filtri: {},
        impostazioni: null
    }),
    async mounted() {
      const backoffice = await configurazioni.getConfigurazione('backoffice', 'impostazioni')
      this.impostazioni = backoffice.eCommerce
      this.headersBO = _.get(backoffice, 'eCommerce.griglia.headers', this.headersDefault)
      this.datiFiscali = _.get(backoffice, 'eCommerce.datiFiscali')
      this.nomeAttributoTaglia = _.get(backoffice, 'eCommerce.nomeAttributoTaglia')
      this.nomeAttributoColore = _.get(backoffice, 'eCommerce.nomeAttributoColore')
      await this.getDataFromApi()
      // await this.calcolaTotali()
    },
    computed: {
      headers() {
        return this.headersSpeciali.concat(this.headersBO).concat(this.headersBase)
      },      
      articoliSorted() {
        if (this.filtroProdotto && this.articoli) {
          return this.articoli.filter(x => String(x.id).startsWith(this.filtroProdotto) || x.name.toLowerCase().includes(this.filtroProdotto.toLowerCase()))
        }
        return this.articoli || []
      }
/*       getNonAssociati() {
        // NON calcola correttamente ... verificare su caso reale
        const numero = this.articoli.filter(x => !x.prodotto).length
        return numero > 0 ? `${numero} articoli non sono associati a prodotti del gestionale` : ''
      } */
    },
    watch: {
      options: {
        async handler () {
          await this.getDataFromApi()
        },
        deep: true
      }
    },    
    methods: {
      async getDataFromApi () {
        try {
          this.loading = true
          this.filtri.isECommerce = true
          this.filtri.eCommerceNonMappato = true
          const data = await prodotti.getFilteredProducts(this.filtri, this.options, null, true)
          const articoli = data && data.total_rows > 0 ? data.rows.map(x => x.doc) : []
          this.articoli = articoli.filter(x => !_.get(x, 'custom.scalaTaglie.prodottoMaster'))
          this.totaleArticoli = data.total_rows
        } catch(err) {
          this.articoli = []
          this.totaleArticoli = 0
        } finally {
          this.loading = false
        }
      },
      async getProdottiNonAssociati() {
        let prodottiEC = await eCommerce.scaricaTuttiProdotti()
        this.articoli = prodottiEC
        await this.verificaCreati()
        this.prodottiNonAssociati = prodottiEC.filter(x => !x.prodotto)
      },
      async calcolaTotali() {
        const totali = await eCommerce.getTotaleProdotti()
        this.totaleArticoli = 0
        for (let t of totali) {
          this.totaleArticoli += t.total
        }
      },
      async onScaricaProdotti() {
        this.loading = true
        await this.getProdottiNonAssociati()
/*         const result = await eCommerce.getElencoProdotti(this.options)
        result.status === 'error' ? this.erroreAccesso = result.message : ''
        this.articoli = result.prodotti */
        // await this.verificaCreati()
        this.loading = false
      },
      async verificaCreati() {
        const creati = await prodotti.getProdottiEcommerce(true)
        this.prodottiAbilitatiECommerce = creati

        for (let itm of creati) {
          // Negli articoli, trova sia quelli con variazioni che quelli semplici ?
          let peC = this.articoli.find(x => String(x.id) === String(itm.eCommerce.id))
          if (peC) {
            peC.prodotto = true
            peC.ubisell = {
              _id: itm._id,
              codice: itm.codice,
              descrizione: itm.descrizione,
              varianti: itm.varianti
            }
          } else {          
            let conVariazioni = this.articoli.find(x => x.variations.some(v => String(v) === String(itm.eCommerce.id)))
            if (conVariazioni) {
              conVariazioni.numAssociati = conVariazioni.numAssociati || conVariazioni.variations.length
              conVariazioni.numAssociati--
              conVariazioni.ubisell = conVariazioni.ubisell || {}
              conVariazioni.ubisell[String(itm.eCommerce.id)] = {
                _id: itm._id,
                codice: itm.codice,
                descrizione: itm.descrizione,
                varianti: itm.varianti
              }              
              if (conVariazioni.numAssociati <= 0) {
                conVariazioni.prodotto = true
              } else {
                conVariazioni.prodotto = false
              }
            }
          }
          // TODO: Deve verificare se tutte le variazioni sono state associate
        }

      },      
      apriCommerce(item) {
        if (item.permalink) {
          window.open(item.permalink)
        }
      },
      allegatiEcommerce(item) {
        return item.allegati && item.allegati.filter(x => ['eCommerce', 'tutto'].includes(_.get(x, 'description.codice'))).length > 0 ? 'blue' : ''
      },   
      annullaSelezione() {
        while(this.selected.length > 0) { this.selected.pop() }
      },      
      async onCreaProdottiEcommerce() {
        /*
          Per creare correttamente i prodotti su eCommerce, lato gestionale si dovrebbe creare un prodotto base che non abbia varianti
          e poi tutti i prodotti con lo stesso codice e con le varianti.
          Per velocizzare, partendo da uno dei prodotti con varianti, filtro tutti i prodotti con lo stesso codice
          e poi crea il master su eComemrce e tutte le varianti (si assume che codice e descrizione delle varianti corrispondano tra ecomemrce e gestionale, 
          altrimenti aggiungere campo codiceEC su gestionale)
          Le funzioni su eCommerce inviano anche eventuali immagini
        */
        this.loading = true
        var codici = _.uniqBy(this.selected, 'codice')
        for (let pr of codici) {
          const filtri = {
            isECommerce: true,
            codice: pr.codice,
            tipoItem: 'PRODOTTO'
          }
          const data = await prodotti.getFilteredProducts(filtri, this.options, null, true)
          const prodottiStessoCodice = data && data.total_rows > 0 ? data.rows.map(x => x.doc) : []
          // TODO: Verificare ritorna prodotti anche se codice comincia uguale --> potrebbe sbagliare se prodotti diversi con la stessa parte iniziale del codice
          // Probabilemente Master scala taglie ....
          let variante1 = []
          let variante2 = []
          // Crea le varianti per tutti i prodotti esistenti anche se ne trasferisce meno ... 
          // Verificare se creando solo quelli esistenti le aggiunge automaticamente aggiungendo una variante
          for (let psc of prodottiStessoCodice) {
            let variante = _.get(psc, 'varianti.variante1')
            if (variante) {
              variante1.push(variante)
            }
            variante = _.get(psc, 'varianti.variante2')
            if (variante) {
              variante2.push(variante)
            }            
          }
          // TODO: Cerca _id=codice ... Verificare se cercare per codice e master scala taglie
          const prodottoMaster = await prodotti.getProdotto(sanitize(pr.codice, true))
          const esistente = _.get(prodottoMaster, 'eCommerce.id')
          var idProdotto
          if (esistente) {
            idProdotto = esistente
            const infoProdotto = await eCommerce.getInfoProdotto(idProdotto)
            if (!infoProdotto) {
              idProdotto = null
            }
          }
          var result
          if (!idProdotto) {
            console.log('Creazione prodotto base: ', prodottoMaster._id)
            result = await eCommerce.creaProdottoBase(this.impostazioni, prodottoMaster, variante1, variante2)
            idProdotto = result.id || 0
          }

          if (idProdotto === 0) {
            alert(`Errore creazione prodotto base: ${prodottoMaster._id}\n${result.message}\nVerificare l'elenco prodotti su eCommerce!`)
            break
          } else {
            if (variante1.length > 0 || variante2.length > 0) {
              const daCreare = _.intersectionBy(prodottiStessoCodice, this.selected, '_id')
              for (let psc of daCreare.filter(x => x._id !== prodottoMaster._id)) {
                if (psc.varianti.variante1 || psc.varianti.variante2) {
                  console.log('Creazione prodotto variante: ', prodottoMaster.psc)
                  result = await eCommerce.creaProdottoVariante(this.impostazioni, idProdotto, psc, psc.varianti.variante1, psc.varianti.variante2)
                  if (result.message) {
                    alert(`Errore creazione variante: ${psc._id}\n${result.message}\nVerificare l'elenco prodotti su eCommerce!`)
                  }
                }
              }
            }
          }
        }
        await prodotti.clearCache()
        this.$emit('refresh')
        this.loading = false
        this.annullaSelezione()
        await this.getDataFromApi()
      },     
      async associaProdotto() {
        this.loading = true
        for (let p of this.articoli.filter(x => x.prodotto)) {
          delete p.prodotto
          delete p.ubisell
        }
        await this.verificaCreati()
        await prodotti.clearCache()
        this.$emit('refresh')
        this.loading = false
        this.annullaSelezione()
        await this.$nextTick()
        this.trigRefresh++
      }
    }
  }
</script>
